import Swiper from 'swiper';
import {
	A11y, Navigation, Pagination,
}             from 'swiper/modules';

/**
 * Create a publications slider using Swiper library
 *
 * @param {HTMLElement} el - The element that contains the slider
 * @returns {Swiper|false} - The created Swiper instance
 *
 * The slider is disabled if the window width is less than 681px.
 * The slider is enabled if the window width is greater than or equal
 * to 681px.
 */
export default function publications(el) {
	if (!el) {
		return false;
	}
	const breakpoint = window.matchMedia('(min-width : 1081px)');
	const slider     = el.querySelector('.swiper');
	const next       = el.querySelector('.swiper-button-next');
	const prev       = el.querySelector('.swiper-button-prev');
	const pagination = el.querySelector('.swiper-pagination');

	let swiper;
	const settings   = {
		modules       : [A11y, Navigation, Pagination],
		loop          : false,
		slidesPerView : 'auto',
		autoHeight    : true,
		spaceBetween  : 0,
		a11y          : {
			prevSlideMessage        : 'Предыдущий слайд',
			nextSlideMessage        : 'Следующий слайд',
			paginationBulletMessage : 'Перейти к {{index}}',
			firstSlideMessage       : 'Первый слайд',
		},
		navigation : {
			nextEl : next,
			prevEl : prev,
		},
		pagination : {
			el             : pagination,
			type           : 'bullets',
			clickable      : true,
			dynamicBullets : false,
		},
	};
	
	const enableSlider = () => {
		swiper = new Swiper(slider, settings);
	};
	
	const breakpointChecker = () => {
		if (breakpoint.matches === true) {
			if (swiper !== undefined) {
				swiper.destroy(true, true);
			}
		}
		if (breakpoint.matches === false) {
			return enableSlider();
		}
		return null;
	};
	try {
		breakpoint.addEventListener('change', breakpointChecker);
	} catch (e) {
		// Safari <14
		breakpoint.addListener(breakpointChecker);
	}
	
	breakpointChecker();
	
	return swiper;
}
